import './assets/css/CustomOrderModal.scss'
import React, {useState} from "react";
import {CustomOrderModalState} from "./interface/CustomOrderModalState";
import CustomOrderModalController from "./controller/CustomOrderModalController";
import AppSettingController from "../../Main/controller/AppSettingController";
import marketSettingLocalStorage from "../../Main/interface/MarketSettingLocalStorage";
import {useTranslation} from "react-i18next";

export default function CustomOrderModal() {
    const {t} = useTranslation();
    const setting = AppSettingController.getSetting() as marketSettingLocalStorage;
    const currency = setting.service === "netbee" ? setting.currency : (setting.currency || t("currency.default"));
    const [state, setState] = useState<CustomOrderModalState>({
        separatorPrice: "",
        price: 0,
    })

    return (
        <div className="custom-order-modal-container">
            <h1>{t("customOrder.title")}</h1>
            <form onSubmit={e => new CustomOrderModalController(state, setState).submit(e)}>
                <label>
                    {t("customOrder.enterPrice")}
                    <div>
                        <input
                            type="text"
                            inputMode="numeric"
                            value={state.separatorPrice}
                            onChange={(e) => new CustomOrderModalController(state, setState).onChanePriceSeparator(e)}/>
                        <span>{currency}</span>
                    </div>
                </label>
                <div className="footer">
                    <div className={'close-modal'} onClick={() => window.dispatchEvent(new Event('closeModal'))}>
                        {t("cancel")}
                    </div>
                    <button className={!state.separatorPrice ? "disabled" : ""} type={"submit"}
                            onClick={e => new CustomOrderModalController(state, setState).submit(e)}>
                        {t("add")}
                    </button>
                </div>
            </form>
        </div>
    );
}